import {
  Button,
  ButtonGroup,
  Content,
  Dialog,
  Divider,
  Heading,
  useDialogContainer,
  Flex,
  useAsyncList,
  Text,
} from "@adobe/react-spectrum";
import React, { useState, useEffect } from "react";
import { useOktaAuth } from "@okta/okta-react";
import PropTypes from "prop-types";
import Table from "../../../Common/Table";
import { SubHistoryCols } from "../../../../constants/Columns";
import { auditApi } from "../../../../api/auditApi";

export default function SubHistoryDialog({ rowInfo }) {
  const { authState } = useOktaAuth();
  const subHistoryCols = SubHistoryCols();

  const dialog = useDialogContainer();
  const searchResultSize = 10;
  const [isSearchLoading, setSearchLoading] = useState("");

  const fetchHistoryRequest = {
    audit_log_id: rowInfo.sub_id,
    users: null,
    page: 0,
    size: searchResultSize,
  };

  const renderCell = (colKey, row) => {
    let cellVal = row[colKey];
    if (colKey === "field_name") cellVal = row.change_log.field_name;
    if (colKey === "old_value") cellVal = row.change_log.old_value;
    if (colKey === "new_value") cellVal = row.change_log.new_value;
    if (colKey === "operation") cellVal = row.meta_data.operation;
    return (
      <span // eslint-disable-line jsx-a11y/no-static-element-interactions
        style={{
          cursor: "text",
          WebkitUserSelect: "text",
        }}
        onPointerDown={(e) => e.stopPropagation()}
        onMouseDown={(e) => e.stopPropagation()}
      >
        <Text>{cellVal}</Text>
      </span>
    );
  };

  const list = useAsyncList({
    initialFilterText: "",
    async load({ filterText, cursor }) {
      let json = {
        results: [],
      };
      const request = cursor || fetchHistoryRequest;

      if (filterText !== "") {
        setSearchLoading("loading");
        json = await auditApi.fetchAuditHistory(request, authState.accessToken);
      }
      const results = json?.results.audit_logs || [];
      setSearchLoading("");
      return {
        items: results,
        cursor:
          results.length < searchResultSize
            ? null
            : {
                ...fetchHistoryRequest,
                page: json?.results.current_page + 1,
              },
      };
    },
    getKey: (item) => item?.id,
  });

  const handleCancel = () => {
    dialog.dismiss();
  };

  useEffect(() => {
    list.setFilterText(rowInfo);
  }, [rowInfo]);

  return (
    <Dialog width="80rem">
      {" "}
      <Heading>{`History: ${rowInfo.sub_name} (${
        rowInfo.parent ? rowInfo.parent_code : rowInfo.sub_code
      })`}</Heading>
      <Divider />
      <Content>
        <Flex marginBottom="15px" height="300px">
          <Table
            columns={subHistoryCols}
            rows={list.items.map((item, index) => ({
              ...item,
              id: index,
            }))}
            loadingState={
              isSearchLoading !== "" ? isSearchLoading : list.loadingState
            }
            onLoadMore={list.loadMore}
            renderCell={renderCell}
            selectionMode="none"
            density="compact"
          />
        </Flex>
      </Content>
      <ButtonGroup>
        <Button onPress={handleCancel} variant="secondary">
          Close
        </Button>
      </ButtonGroup>
    </Dialog>
  );
}

SubHistoryDialog.propTypes = {
  rowInfo: PropTypes.objectOf(
    PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
      PropTypes.bool,
      PropTypes.array,
      PropTypes.object,
      PropTypes.arrayOf(PropTypes.object),
    ])
  ).isRequired,
};
